module.exports = __webpack_public_path__ + "static/media/postcards.50368161.jpg";